// Tiny localStorage helpers for the ExploreDeck auto-open preference.
// Once the user hits "View classic display", we remember that — future
// BuildDeck completions won't auto-open the 3D view. They can still
// trigger it manually via "Explore deck".

const KEY = "mtgOracle.exploreDeck.autoOpen";

export function shouldAutoOpen(): boolean {
  if (typeof window === "undefined") return false;
  const v = window.localStorage.getItem(KEY);
  // Default true: first-time users get the wow moment.
  return v !== "false";
}

export function setAutoOpen(enabled: boolean): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, enabled ? "true" : "false");
}
